// In src/hooks/useUrlTab.js

import { useSearchParams } from 'react-router-dom';

const useUrlTab = (defaultTab) => {
    const [searchParams, setSearchParams] = useSearchParams();

    // ✅ This line runs on EVERY render
    const activeTab = searchParams.get('tab') || defaultTab;

    const handleTabChange = (tab) => {
        setSearchParams({ tab });
    };

    return [activeTab, handleTabChange];
};

export default useUrlTab;